import React from "react";
import { motion } from "framer-motion";
import "./Aboutus.css";
import storyImg from "../../assets/slide6.jpg";
import aboutImg from "../../assets/slide9.jpeg";
import {Link} from 'react-router-dom';

const AboutUs = () => {
  return (
    <section className="about-container">
      {/* Header */}
      <motion.div
      
        className="about-header"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
         <h2>
          About <span>Us</span>
        </h2>
       
        <p>
          Our vision is to be known as the go-to staffing solution for IT
          companies all over the world. We want to help existing and upcoming IT
          professionals to be knowledgeable in current technologies so they can
          compete on a global stage.
        </p>
      </motion.div>

      {/* Our Story */}
      <motion.div
        className="about-story"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <div className="story-text">
          <motion.h3
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            Our Story
          </motion.h3>
          <motion.p
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Lyros was founded with a mission to bridge the gap between
            exceptional talent and leading enterprises. Over the years, we’ve
            evolved into a trusted partner, delivering technology solutions and
            workforce management services across industries.
          </motion.p>
        </div>
        <motion.div
          className="story-img"
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <img src={storyImg} alt="Our Story" />
        </motion.div>
      </motion.div>

      {/* Principles */}
      <motion.div
        className="about-section principles"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h3>Fundamental Principles</h3>
        <motion.div
          className="principles-grid"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: { transition: { staggerChildren: 0.2 } },
          }}
        >
          {[
            {
              icon: "🌟",
              title: "Excellence",
              text: "We strive for quality and deliver outstanding results in every engagement.",
            },
            {
              icon: "🤝",
              title: "Trust & Transparency",
              text: "We build long-term partnerships based on honesty and open communication.",
            },
            {
              icon: "🚀",
              title: "Agility",
              text: "We adapt quickly to evolving needs with flexible and innovative solutions.",
            },
            {
              icon: "🌍",
              title: "Global Perspective",
              text: "We combine international expertise with local knowledge to maximize impact.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="principle-card"
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.6 }}
            >
              <span className="icon">{item.icon}</span>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>

      {/* Driving Results */}
      <motion.div
        className="about-section driving-results"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="results-content">
          <h3>Driving Results with Real Impact</h3>
          <p>
            At Lyros, we go beyond staffing and solutions—we create meaningful
            results that help businesses grow. Our commitment lies in delivering
            measurable value, empowering organizations with the right talent,
            and building long-term success stories.
          </p>

          {/* Stats Section */}
          <motion.div
            className="stats-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: {},
              visible: { transition: { staggerChildren: 0.2 } },
            }}
          >
            {[
              { number: "2,160+", label: "Candidates Placed" },
              { number: "54+", label: "Satisfied Clients" },
              { number: "18+", label: "Expert Consultants" },
            ].map((stat, i) => (
              <motion.div
                key={i}
                className="stat-card"
                variants={{
                  hidden: { opacity: 0, y: 40 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.7 }}
              >
                <h4 className="counter">{stat.number}</h4>
                <p>{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Right Side Image */}
        <motion.div
          className="results-image"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.9 }}
        >
          <img src={aboutImg} alt="Our Story" />
        </motion.div>
      </motion.div>

      {/* Values */}
      <motion.div
        className="about-section values"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h3>Our Values</h3>
        <div className="values-grid">
          {[
            {
              icon: "🛡️",
              title: "Integrity",
              text: "We act with honesty and uphold strong ethical standards in everything we do.",
            },
            {
              icon: "💡",
              title: "Innovation",
              text: "We embrace change, drive creativity, and bring forward-thinking solutions.",
            },
            {
              icon: "🤝",
              title: "Collaboration",
              text: "We believe in the power of teamwork to achieve extraordinary results.",
            },
            {
              icon: "🚀",
              title: "Customer Success",
              text: "Your growth defines our success — we thrive when our clients succeed.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="value-card"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <span className="icon">{item.icon}</span>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Join Us */}
      <motion.div
        className="about-join"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
      >
        <h3>Join With Us</h3>
        <p>
          Become part of our journey and explore opportunities to grow your
          career while making a difference. At Lyros, we welcome passionate
          minds to create the future together.
        </p>
       <Link
                       to="/contact" // ✅ Navigate to Contact page
                       className="btn-primary"
                       aria-label="Contact Lyros"
                     >
                 Contact Us
                     </Link>
      </motion.div>
    </section>
  );
};

export default AboutUs;
